import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/spore/runtime";
import Stage from "@/pages/Stage";
import Lab from "@/pages/Lab";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Stage />} />
          <Route path="/lab" element={<Lab />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
